var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "filters__section",
      class: {
        "u-margin-bottom-none": _vm.enableSupplierFocusedSearch,
      },
    },
    [
      _c("FiltersInitial", {
        attrs: {
          APICall: _vm.APICall,
          applyFiltersText: _vm.applyFiltersText,
          applyFiltersToAPICall: _vm.applyFiltersToAPICall,
          disableSubRegionDropdown: _vm.disableSubRegionDropdown,
          deleteSubRegions: _vm.deleteSubRegions,
          isTab2: _vm.isTab2,
          locations: _vm.locations,
          optionalExpanded: _vm.optionalExpanded,
          selectedRegion: _vm.selectedRegion,
          selectedSubRegions: _vm.selectedSubRegions,
          subRegionsForRegion: _vm.subRegionsForRegion,
          updateRegion: _vm.updateRegion,
          updateShowOptions: _vm.updateShowOptions,
          updateSubRegions: _vm.updateSubRegions,
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          class: [
            _vm.optionalExpanded
              ? "filters__optional-filters"
              : "filters__optional-filters filters__optional-filters--hidden utility-hidden",
          ],
          attrs: {
            tabindex: [_vm.optionalExpanded ? "0" : "-1"],
            "aria-label": "Optional Filters",
          },
        },
        [
          _c("FiltersOptional", {
            attrs: {
              APICall: _vm.APICall,
              applyFiltersText: _vm.applyFiltersText,
              applyFiltersToAPICall: _vm.applyFiltersToAPICall,
              clearAllFilters: _vm.clearAllFilters,
              clearFiltersText: _vm.clearFiltersText,
              culturalExperience: _vm.culturalExperience,
              genders: _vm.genders,
              languages: _vm.languages,
              optionalExpanded: _vm.optionalExpanded,
              removeFilterFromButton: _vm.removeFilterFromButton,
              selectedCulturalExperience: _vm.selectedCulturalExperience,
              selectedGenders: _vm.selectedGenders,
              selectedLanguages: _vm.selectedLanguages,
              selectedTherapistExperience: _vm.selectedTherapistExperience,
              therapistExperience: _vm.therapistExperience,
              updateFilterFromButton: _vm.updateFilterFromButton,
              updateShowOptions: _vm.updateShowOptions,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }